import { Skeleton } from '@/shared/components/ui/skeleton';

/** Route-level pending shape matching the task-request detail layout. */
export function TaskRequestDetailSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 overflow-auto p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl">
        <header className="space-y-3 border-b pb-4">
          <Skeleton className="h-8 w-32 rounded-md" />
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-7 w-80 max-w-full" />
              <Skeleton className="h-5 w-64 max-w-full" />
            </div>
            <Skeleton className="h-8 w-24 rounded-md" />
          </div>
        </header>

        <div className="mt-5 grid gap-6 lg:grid-cols-[minmax(0,1fr)_16rem]">
          <main className="min-w-0 space-y-5">
            <Skeleton className="h-44 w-full rounded-md" />
            <Skeleton className="h-40 w-full rounded-md" />
            <Skeleton className="h-64 w-full rounded-md" />
          </main>
          <aside className="space-y-5 border-y py-4 lg:border-t-0 lg:pt-0">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-1/2" />
          </aside>
        </div>
      </div>
    </div>
  );
}
